import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API } from '../../app.config';
import { Observable, of } from 'rxjs';
import { TradutorRQ, TradutorRS } from '../../model';
import { map, catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class TradutorService {

  constructor(private http: HttpClient) { }

  TraduzirIA(TradutorRQ: TradutorRQ): Observable<TradutorRS> {
    const headers = new HttpHeaders().set('noloader', 't');
    return this.http.post<any>(`${API}/api/tradutor/traduzir`, TradutorRQ, { headers: headers });
  }

  Traduzir(tradutorRQ: TradutorRQ): Observable<string> {
      let text = tradutorRQ.Conteudo;
      const regex = /(Cancelamento a partir de )(\d{2}\/\d{2}\/\d{4})( multa de 100% do valor da reserva\.)/;
      const match = text.match(regex);
      let date = "";
  
      if (match) {
        date = match[2]; // Captura a data
        tradutorRQ.Conteudo = text.replace(regex, "$1[DATA_REMOVIDA]$3");
      }
  
      return this.TraduzirIA(tradutorRQ).pipe(
        map(dados => {
          let translatedText = dados.Conteudo;
          return translatedText.replace("[DATA_REMOVIDA]", date);
        }),
        catchError(error => {
          console.error("Erro ao traduzir:", error);
          return of("Erro na tradução");
        })
      );
    }
}
